/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict"

    interface ICollegeRedirection {
    }

    interface ICollegeRedirectionScope extends ng.IScope {
        vm: CollegeRedirection;
        dateOptions: any;
    }

    interface Prospect {
        additionalData: any;
    }

    class Address implements IAddress {
        addressType: string;
        firstName: string;
        lastName: string;
        street: string;
        street2: string;
        city: string;
        state: string;
        postalCode: string;
        country: string;
        county: string;
        isVerified: boolean;
        resultCodes: string;
        userOverride: boolean;
        signature: string;
        key: string;
    }

    class VerifyAddressResults implements IVerifyAddressResultsViewModel {
        firstName: string;
        lastName: string;
        action: string;
        providedAddressHasErrors: boolean;
        key: string;
        providedAddress: Address;
        suggestedAddress: Address;

    }

    class CollegeRedirection implements ICollegeRedirection {
        static $inject: Array<string> = ["$uibModal", "common", "Restangular", "$scope", "addressService"];
        static controllerId: string = "collegeRedirection";
        private log;
        firstName: string;
        middleName: string;
        lastName: string;
        suffix: string;
        streetAddress: string;
        city: string;
        state: string;
        zipCode: number;
        country: string;
        intlZipCode: number;
        phoneNumber: string;
        dateOfBirth: Date;
        emailAddress: string;
        usCitizen: boolean;
        areHispanic: boolean;
        race: Array<string>;
        highSchool: any;
        CEEBCode: any;
        gradDate: string;
        classRank: number;
        weightedGPA: number;
        unweightedGPA: number;
        satComposite: number;
        satMath: number;
        satWriting: number;
        satEssay: number;
        satMultipleChoice: number;
        actEnglish: number;
        actMath: number;
        actReading: number;
        actScience: number;
        actEnglishCombined: number;
        actWritingSubscore: number;
        actComposite: number;
        intendedMajor: string;
        requireHousing: boolean;
        dateOfBirthOpen: boolean;
        gradDateOpen: boolean;
        defaultCategory: string;
        showInputText: boolean;
        showSubmitText: boolean;
        showProcessing: boolean;
        maxDate: Date;
        userProfile: any;
        melissaDataResponse: any;
        addressError: boolean;
        demographics: any;
        parentGuardian: any;
        doSubmitProspect: boolean;
        originalEmail: string;
        appliedToUncInstitution: any;
        deniedAdmission: any;
        acceptedToUncInstitution: any;
        denialsReceivedFrom: Array<any>;
        acceptedFrom: Array<any>;
        entryTerm: any;
        entryYear: any;
        uncColleges: Array<any>;
        minDate: Date;
        currentYear: any;
        ncCounties: Array<IAddressListItem>;
        textAuth: any;
        applyFinAid: any;
        logError: (msg, data?, showToast?) => void;

        constructor(private $uibModal: ng.ui.bootstrap.IModalService, private common: ICommonFactory, private Restangular: Restangular.IService, private $scope: ICollegeRedirectionScope, private addressService: IAddressService) {
            this.log = common.logger.getLogFn(CollegeRedirection.controllerId);
            this.logError = common.logger.getLogFn(CollegeRedirection.controllerId, "error");
            this.minDate = new Date(1899, 12);
            this.ncCounties = this.addressService.ncCountyList;

            var month: number = new Date().getMonth();

            this.currentYear = new Date().getFullYear();
            if (month >= 9)
                this.currentYear++;

            $scope.dateOptions = {
                showWeeks: false,
            };
            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.activate();
                }
            });

        }

        activate() {
            var promises = [];
            this.common.activateController(promises, CollegeRedirection.controllerId)
                .then(() => {
                this.log("Activated CRP");
                this.dateOfBirthOpen = false;
                this.gradDateOpen = false;
                this.showInputText = true;
                this.showSubmitText = false;
                this.showProcessing = false;
                this.defaultCategory = "PK-12";
                this.country = "US";
                this.emailAddress = "";
                this.race = [];
                this.maxDate = new Date();
                this.doSubmitProspect = false;
                this.getUserProfile();
                this.getUserDemographics();
                    this.getParentGuardianInfo();
                    this.getUncSchools();
            });
        }

        getUncSchools() {
            return this.Restangular.all("institutions/getSchoolList").getList().then((result) => {
                this.uncColleges = result;

            }, (reason) => {
                this.logError(reason, reason, true);
            });
        }

        checkList(listTocheck: any, name: string) {
            var found = false;
            for (var i in listTocheck) {
                if (listTocheck[i] == name)
                    found = true;
            }
            return found;
        }

        modifyList(listTocheck: any, name: string) {
            var found = false;
            for (var i in listTocheck) {
                if (listTocheck[i] == name) {
                    found = true;
                    listTocheck.splice(i, 1);
                }
            }
            if (!found) {
                listTocheck.push(name);
            }
        }

        submitProspect() {
            var denials = _.replace(_.map(this.denialsReceivedFrom, 'name').toString(), new RegExp(',', "g"), ';');
            var accept = _.replace(_.map(this.acceptedFrom, 'name').toString(), new RegExp(',', "g"), ';');
            var Name = { First: this.userProfile.firstName, Middle: this.userProfile.middleName, Last: this.userProfile.lastName, Suffix: this.userProfile.suffix };
            var mailAddress = { Street1: this.userProfile.mailAddress.street, Street2: "", City: this.userProfile.mailAddress.city, State: this.userProfile.mailAddress.state, Country: this.userProfile.mailAddress.country, Zip: this.userProfile.mailAddress.postalCode };
            var permAddress = { Street1: this.userProfile.permAddress.street, Street2: "", City: this.userProfile.permAddress.city, State: this.userProfile.permAddress.state, Country: this.userProfile.permAddress.country, Zip: this.userProfile.permAddress.postalCode };
            var additionalData = {
                internationalPostalCode: this.intlZipCode,
                daytimePhone: this.userProfile.daytimePhone,
                birthDate: this.userProfile.dateOfBirth,
                highSchool: this.userProfile.customer.name,
                ceebCode: this.userProfile.customer.ceeb_code,
                gradDate: this.gradDate,
                classRank: this.classRank,
                weightedGPA: this.weightedGPA,
                unweightedGPA: this.unweightedGPA,
                satComposite: this.satComposite,
                actComposite: this.actComposite,
                intendedMajor: this.intendedMajor,
                requireCampusHousing: this.requireHousing,
                mailingPhone: this.userProfile.mailingPhone,
                permanentPhone: this.userProfile.phoneNumber,
                eveningPhone: this.userProfile.eveningPhone,
                mobilePhone: this.userProfile.mobilePhone,
                graduationYear: this.userProfile.graduationYear,
                gender: this.userProfile.gender,
                socialSecurityNumber: this.userProfile.socialSecurityNumber,
                nickname: this.userProfile.nickname,
                enrollmentStatus: this.userProfile.enrollmentStatus,
                nationalities: this.demographics.nationalities,
                religiousAffiliation: this.demographics.religiousAffiliation,
                maritalStatus: this.demographics.maritalStatus,
                disabilities: this.demographics.disabilities,
                militaryServices: this.demographics.militaryServices,
                parentFirstName: this.parentGuardian.firstName,
                parentLastName: this.parentGuardian.lastName,
                parentAddressStreet1: this.parentGuardian.address != null ? this.parentGuardian.address.street : "",
                parentAddressStreet2: this.parentGuardian.address != null ? this.parentGuardian.address.street2 : "",
                parentAddressCity: this.parentGuardian.address != null ? this.parentGuardian.address.city : "",
                parentAddressState: this.parentGuardian.address != null ? this.parentGuardian.address.state : "",
                parentAddressCountry: this.parentGuardian.address != null ? this.parentGuardian.address.country : "",
                parentAddressZip: this.parentGuardian.address != null ? this.parentGuardian.address.postalCode : "",
                parentEmailAddress: this.parentGuardian.emailAddress,
                parentPhoneNumber: this.parentGuardian.phoneNumber,
                isFatherLiving: this.parentGuardian.isFatherLiving,
                isMotherLiving: this.parentGuardian.isMotherLiving,
                isParentVeteran: this.parentGuardian.isParentVeteran,
                parentDisabledInMilitary: this.parentGuardian.parentDisabledInMilitary,
                parentKilledInMilitary: this.parentGuardian.parentKilledInMilitary,
                parentsGraduatedCollege: this.parentGuardian.parentsGraduatedCollege,
                appliedToUncInstitution: this.appliedToUncInstitution,
                deniedAdmission: this.deniedAdmission,
                acceptedToUncInstitution: this.acceptedToUncInstitution,
                denialsReceivedFrom: denials,
                acceptedFrom: accept,
                entryTerm: this.entryTerm,
                entryYear: this.entryYear,
                textAuth: this.textAuth,
                applyFinancialAid: this.applyFinAid
            };
            var prospect = { id: "", applicationDefinitionId: "", userId: "", source: "CRP", name: Name, mailingAddress: mailAddress, physicalAddress: permAddress, email: this.userProfile.email, dateCreated: new Date(), additionalData: additionalData }; 
            this.Restangular.all("Prospect/insertprospectcrp").post(prospect).then((results) => {
                this.showProcessing = false;
                this.showSubmitText = true;
            },(reason) => {
                this.logError(reason, reason, true);
                });
        }

        getUserProfile() {
            this.Restangular.one("users/profile").get().then((results) => {
                this.userProfile = results;
                this.originalEmail = this.userProfile.email;
            },(reason) => {
                this.logError(reason, reason, true);
                });
        }

        getUserDemographics() {
            this.Restangular.one("users/demographics").get().then((result) => {
                this.demographics = result;
            }, (reason) => {
                this.logError(reason, reason, true);
            });
        }

        getParentGuardianInfo() {
            this.Restangular.one("users/parentguardianinfo").get().then((result) => {
                this.parentGuardian = result;
            }, (reason) => {
                this.logError(reason, reason, true);
            });
        }

        selectAddressOkCallback = (selectedAddress: Array<Address>) => {
            selectedAddress.forEach((selection) => {
                if (selection.key == "permanent") {
                    this.userProfile.permAddress.city = selection.city;
                    this.userProfile.permAddress.postalCode = selection.postalCode;
                    this.userProfile.permAddress.state = selection.state;
                    this.userProfile.permAddress.street = selection.street;
                    this.userProfile.permAddress.street2 = selection.street2;
                    this.userProfile.permAddress.isVerified = selection.isVerified;
                    this.userProfile.permAddress.userOverride = selection.userOverride;
                    this.userProfile.permAddress.resultCodes = selection.resultCodes;
                    this.userProfile.permAddress.signature = selection.signature;
                    this.userProfile.permAddress.addressType = selection.addressType;
                    this.userProfile.permAddress.county = selection.county;
                }
            });

            this.userProfile.addressVerified = true;
            this.showProcessing = true;
            this.showInputText = false;
            if (this.doSubmitProspect) {
                this.submitProspect();
                this.doSubmitProspect = false;
            }
            this.updateUserProfile();
        };

        selectAddressCancelCallback = (selectedAddress: Array<Address>) => {
            selectedAddress.forEach((selection) => {
                if (selection.key == "permanent") {
                    this.userProfile.permCity = selection.city;
                    this.userProfile.permPostalCode = selection.postalCode;
                    this.userProfile.permState = selection.state;
                    this.userProfile.permStreet = selection.street;
                    this.userProfile.permStreet2 = selection.street2;
                    this.userProfile.permAddressSignature = selection.signature;
                    this.userProfile.permAddressType = selection.addressType;
                }
            });
            this.showProcessing = false;
            this.showInputText = true;
        }

        updateUserProfile() {
            this.showProcessing = true;
            this.showInputText = false;
            var mailAddress = _.cloneDeep(this.userProfile.mailAddress);

            if (!this.userProfile.addressVerified) {
                var permAddress = new Address();
                permAddress.firstName = this.userProfile.firstName;
                permAddress.lastName = this.userProfile.lastName;
                permAddress.street = this.userProfile.permAddress.street;
                permAddress.street2 = null;
                permAddress.city = this.userProfile.permAddress.city;
                permAddress.state = this.userProfile.permAddress.state;
                permAddress.postalCode = this.userProfile.permAddress.postalCode;
                permAddress.country = this.userProfile.permAddress.country;
                permAddress.county = this.userProfile.permAddress.county;
                
                var addressErrorResults = new Array<VerifyAddressResults>();
                this.Restangular.all("Address").all("Validate").post(permAddress).then((response: VerifyAddressResults) => {
                    if (response.providedAddressHasErrors) {
                        response.key = "permanent";
                        addressErrorResults.push(response);
                    } else {
                        this.userProfile.permAddress.signature = response.providedAddress.signature;
                        this.userProfile.permAddress.addressType = response.providedAddress.addressType;
                        this.userProfile.permAddress.userOverride = false;
                        this.userProfile.permAddress.isVerified = true;
                        this.userProfile.permAddress.resultCodes = response.providedAddress.resultCodes;
                    }

                    if (addressErrorResults.length > 0) {
                        this.addressError = true;
                        this.melissaDataResponse = addressErrorResults;
                    } else {
                        this.userProfile.mailAddress = null;
                        this.Restangular.all("users/profile/save").customPUT(this.userProfile).then((results) => {
                            if (this.doSubmitProspect) {
                                this.userProfile.mailAddress = _.cloneDeep(mailAddress);
                                this.submitProspect();
                                this.doSubmitProspect = false;
                            }
                        }, (reason) => {
                            this.showProcessing = false;
                            this.showInputText = true;

                            this.logError(reason, reason, true);

                        });
                    }
                });
            } else {
                this.userProfile.mailAddress = null;
                this.Restangular.all("users/profile/save").customPUT(this.userProfile).then((results) => {
                    if (this.doSubmitProspect) {
                        this.userProfile.mailAddress = mailAddress;
                        this.submitProspect();
                        this.doSubmitProspect = false;
                    }
                }, (reason) => {
                    this.showProcessing = false;
                    this.showInputText = true;

                    this.logError(reason, reason, true);

                });
            };
        }

        testModal() {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/collegePlanning/ConfirmModal.html',
                controller: 'ConfirmModal',
            });
        }
    }
    angular.module("app").controller(CollegeRedirection.controllerId, CollegeRedirection);
} 